import { render, staticRenderFns } from "./OrderGuest.vue?vue&type=template&id=af1d68a6&scoped=true&"
import script from "./OrderGuest.vue?vue&type=script&lang=js&"
export * from "./OrderGuest.vue?vue&type=script&lang=js&"
import style0 from "./OrderGuest.vue?vue&type=style&index=0&id=af1d68a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d68a6",
  null
  
)

export default component.exports